import THGTracker from '../../tracking/thg/THGTracker';
import Page from '../../enums/Page';
import {getCookie} from '../utils/cookie-monster';
import Track from '../utils/tracking';
import device from './device';
import getUsedPaymentType from './getUsedPaymentType';
import JsonHelper from './jsonHelper';
import getPage from '../page/getPage';
import request from './request';

class BigQueryOrderRecorder {
  isEnabled = () => {
    const {settings} = window.start;
    if (settings.checkout_tracking_url && settings.checkout_conversion_tracking_enabled) {
      this.url = settings.checkout_tracking_url;
      return true;
    }
    return false;
  };
  
  getEventData = () => {
    const deviceInfo = device.getType();
  
    const getDeviceType = () => {
      if (deviceInfo.is_pc) {
        return 'desktop';
      }
      if (deviceInfo.is_mobile) {
        return 'mobile';
      }
      if (deviceInfo.is_app) {
        return 'app';
      }
    
      return 'tablet';
    };
  
    const getCustomerType = () => {
      if (window.start.guestCheckout) {
        return 'guest';
      }
    
      if (window.start.customer?.newCustomer) {
        return 'new';
      }
    
      return 'returning';
    };
    
    const getOrderNumber = () => {
      const orderNumber = window.start.orderNumber
      
      const match = orderNumber.match(/\D/);
      
      // If a non-digit character is found
      if (match) {
        const index = match.index;
        return {
          orderNumber: orderNumber.slice(0, index),
          orderNumberSuffix: orderNumber.slice(index),
        }
      }
      
      // If no non-digit character is found, return the original string in one array element
      return {
        orderNumber: orderNumber,
      }
    }
    
    const getDeliveryIds = () => {
      const orderNumberSuffix = getOrderNumber().orderNumberSuffix
      
      if (orderNumberSuffix) {
        const match = orderNumberSuffix.match(/\d/);
        
        // If a non-digit character is found
        if (match) {
          const index = match.index;
          const orderNumberSuffixNumeric = orderNumberSuffix.slice(index);
          return [-Math.abs(orderNumberSuffixNumeric)];
        }
      }
      
      return []
    }
    
    const getChumeweUserCookie = () => {
      return device.getDeviceData().device.cookie;
    }
    
    const getChumeweSessionCookie = () => {
      return device.getDeviceData().device.sess_cookie;
    }
    
    
    
    const baseProperties = [
      {timestamp: window.start?.timeStamp || request.getClientTimestamp()},
      {orderNumber: getOrderNumber().orderNumber},
      {customerId: window.start.customer?.customerId},
      {customerType: getCustomerType()},
      {siteId: window.start.siteDataV2?.siteId},
      {siteCode: window.start.siteDataV2?.siteCode},
      {locale: window.start.siteDataV2?.locale},
      {currency: window.start.orderTotal?.currencyCode},
      {os: deviceInfo.family},
      {device: getDeviceType()},
      {browser: device.getBrowserData()?.family},
      {userAgent: window.navigator?.userAgent},
      {deliveryCountry: (getPage() === Page.COMPLETE) ? window.start.order?.deliveryAddress?.countryCode : window.start.deliveryAddress?.countryCode},
      {paymentMethod: getUsedPaymentType(false)},
      {deliveryIds: getDeliveryIds()}, // todo - Currently being used to contain the suffix of an order number if the order is a subscription
      {fulfilmentType: getPage()}, // todo - Not available in complete page start, api needs to return this data in the complete page start object
    ];
    
    // Add chumwe cookie attributes if the setting is enabled
    if (window.start.settings?.enable_chumwe_cookie_attributes_for_conversion_tracking) {
      baseProperties.push(
        {chumeweUser: getChumeweUserCookie()},
        {chumeweSess: getChumeweSessionCookie()}
      );
    }
    
    return JsonHelper.getJsonMessage(...baseProperties);
  }
  
  sendMetric = () => new Promise((resolve) => {
    if (this.isEnabled()) {
      THGTracker.sendConversionTables(this.url, this.getEventData(), 'checkoutOrder');
    }
    resolve();
  })
    .catch((error) => {
      Track.track(`Failed to send order data to big query. ${error}`);
    });
}

export default () => new BigQueryOrderRecorder().sendMetric();
